import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './styles/global.css'

Vue.config.productionTip = false

// SSO 兼容：如果 Gateway 回跳到 /login?redirect=... 或 /auth?redirect=...（无 hash），
// 把 URL 改写成 hash 模式的 /#/login?redirect=...，否则 hash 路由看不到 /login
;(function adaptSsoRedirectUrl() {
  try {
    const path = window.location.pathname
    const search = window.location.search
    if (!search) return
    const params = new URLSearchParams(search)
    if (!params.get('redirect')) return
    if (path === '/login' || path === '/auth') {
      // 保留 search，移到 hash 里；不再 reload 整页
      const newUrl = window.location.origin + '/#' + path + search
      window.history.replaceState(null, '', newUrl)
    }
  } catch (e) { /* noop */ }
})()

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
